"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType["ERROR"] = "error";
    MessageType["SUCCESS"] = "success";
    MessageType["INFO"] = "info";
    MessageType["HELLO"] = "hello";
    MessageType["HELLOL"] = "helloL";
    MessageType["ERRORL"] = "errorL";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
//# sourceMappingURL=MessageProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Message/MessageProps.js
// module id = 143
// module chunks = 8